<app-upsell-card [htmlTitle]="htmlTitle" [question]="question" [slug]="slug">
  <ng-content>
    <p class="mb-4">
      Many patients on metformin choose to add Vitamin D to their regimen to
      <strong>support energy, mood, and long-term wellness</strong>. Vitamin D is essential for strong bones, a
      resilient immune system, and youthful vitality. Don’t let a common deficiency hold you back—optimize your health
      and enhance your results today.
    </p>
  </ng-content>
</app-upsell-card>
